import React from 'react';
import { isAlertCancelled } from 'helpers/conditionMonitoringAlert';

/**
 * Custom dot renderer for points where a Condition Monitoring alert fired.
 * Renders a ringing bell (alert) icon — deliberately distinct from the defect
 * warning triangle — coloured by the user's decision:
 *  - Acknowledge: amber (reading accepted)
 *  - Cancel: grey + a red strike, so cancelled readings read distinctly
 * Click handling is done by the parent component.
 */
const AlertDot = (props) => {
  const { cx, cy, className, decision } = props;
  const s = 9;
  const isCancelled = isAlertCancelled(decision);

  const fill = isCancelled ? '#BDBDBD' : '#F5A623';
  const stroke = isCancelled ? '#757575' : '#B5790A';

  // Filled bell body (dome + flared rim), drawn as a single shape.
  const bell = `
    M ${cx},${cy - s}
    C ${cx + s * 0.62},${cy - s * 0.82} ${cx + s * 0.6},${cy - s * 0.2} ${cx + s * 0.62},${cy + s * 0.25}
    C ${cx + s * 0.63},${cy + s * 0.42} ${cx + s * 0.8},${cy + s * 0.42} ${cx + s * 0.9},${cy + s * 0.55}
    L ${cx - s * 0.9},${cy + s * 0.55}
    C ${cx - s * 0.8},${cy + s * 0.42} ${cx - s * 0.63},${cy + s * 0.42} ${cx - s * 0.62},${cy + s * 0.25}
    C ${cx - s * 0.6},${cy - s * 0.2} ${cx - s * 0.62},${cy - s * 0.82} ${cx},${cy - s}
    Z
  `;

  return (
    <g className={className}>
      {/* Sound-wave ticks (the "ringing") */}
      <path
        d={`M ${cx - s * 1.0},${cy - s * 0.55} A ${s * 0.55},${s * 0.55} 0 0 0 ${cx - s * 1.0},${cy + s * 0.25}`}
        fill="none"
        stroke={stroke}
        strokeWidth={1.4}
        strokeLinecap="round"
      />
      <path
        d={`M ${cx + s * 1.0},${cy - s * 0.55} A ${s * 0.55},${s * 0.55} 0 0 1 ${cx + s * 1.0},${cy + s * 0.25}`}
        fill="none"
        stroke={stroke}
        strokeWidth={1.4}
        strokeLinecap="round"
      />
      {/* Bell top knob */}
      <circle cx={cx} cy={cy - s * 1.05} r={s * 0.2} fill={fill} stroke={stroke} strokeWidth={0.75} />
      {/* Bell body */}
      <path d={bell} fill={fill} stroke={stroke} strokeWidth={1} strokeLinejoin="round" />
      {/* Clapper */}
      <circle cx={cx} cy={cy + s * 0.82} r={s * 0.22} fill={fill} stroke={stroke} strokeWidth={0.75} />
      {/* Strike line for cancelled readings */}
      {isCancelled && (
        <line x1={cx - s * 1.05} y1={cy + s} x2={cx + s * 1.05} y2={cy - s} stroke="#D32F2F" strokeWidth={1.75} />
      )}
    </g>
  );
};

export default AlertDot;
